(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/self-exclusion-react/assets/react/components/periods.js') >= 0) return;  svs.modules.push('/modules/self-exclusion-react/assets/react/components/periods.js');
'use strict';

const dates = svs.selfExclusion.dates;
const {
  ControlGroup,
  Select,
  Option
} = svs.ui.ReactForm;
const {
  isPnp,
  periodsLabelText
} = svs.selfExclusion.Constants;
const Periods = _ref => {
  let {
    onHandlePeriod,
    exclusionDates,
    exclusions,
    period,
    isSubmitted
  } = _ref;
  const allGamesExpiry = svs.selfExclusion.useAllExclusions(exclusions);
  const handleChange = periodValue => {
    const foundDate = dates.find(date => date.value === Number(periodValue));
    onHandlePeriod(foundDate);
  };
  return React.createElement(ControlGroup, {
    errorMessage: "Du m\xE5ste v\xE4lja en period",
    hasError: isSubmitted && !period,
    v2: true
  }, React.createElement("label", {
    className: "styled-label"
  }, periodsLabelText, React.createElement(Select, {
    id: "reactSelect",
    inverted: isPnp,
    onChange: e => handleChange(e.target.value),
    v2: true,
    value: (period === null || period === void 0 ? void 0 : period.value.toString()) || ''
  }, React.createElement(Option, null), exclusionDates.map(date => React.createElement(Option, {
    disabled: date.isExcluded || dateFns.isBefore(date.willExpire, allGamesExpiry),
    key: date.id,
    value: date.value.toString()
  }, date.text)))));
};
svs.selfExclusion.components.Periods = Periods;

 })(window);